import { Img } from "components/Img";

const FounderActionCard = ({ element, handleOpenDrawer, onDelete, isError }:any) => {
    return ( 
        <div
                    className={`bg-white rounded-lg shadow-lg ${isError ? 'shadow-red-500' : ""} py-1 px-3 h-full w-full flex flex-col`}
                    style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                    {/* Header section with avatar, name, and action buttons */}
                    <div className="flex items-center gap-2">
                        {!!element?.INSTITUTE_LEADER_IMAGE?.selectedImage ? <Img src={element?.INSTITUTE_LEADER_IMAGE?.selectedImage} className="w-[6vh] h-[6vh] rounded-full" /> : <div className="w-[6vh] h-[6vh] bg-gray-200 rounded-full flex items-center justify-center">
                            <span className="text-[2vh] text-gray-500 font-medium">
                                {!!element.INSTITUTE_LEADER_NAME ? element.INSTITUTE_LEADER_NAME.charAt(0) : ""}
                            </span>
                        </div>}

                        <div className="flex-1 ">
                            <p
                                className="text-[2vh] font-medium text-gray-900 text-sm truncate"
                                title={element.INSTITUTE_LEADER_NAME}
                                style={{ maxWidth: "20ch" }}
                            >
                                {element.INSTITUTE_LEADER_NAME}
                            </p>
                            <p className="text-gray-500 text-[1.8vh]">
                                {/* {element.agetrue ? `${"element.age"} Years old` : ""} */}
                                {/* {element.age && element.gender && " | "} */}
                                {!!element.GENDER ? element.GENDER : ""}
                            </p>
                        </div>

                        <div className="flex space-x-2">
                           {!!handleOpenDrawer && <button
                                onClick={() => handleOpenDrawer()}
                                className="text-gray-500 hover:text-blue-600"
                                type="button"
                            >
                                <img src="/images/edit-3.svg" alt="edit" className="w-[2.7vh] h-[2.7vh]" />
                            </button>}
                          {!!onDelete && <button
                                onClick={onDelete}
                                className="text-gray-500 hover:text-red-600"
                                type="button"
                            >
                                <img src="/images/trash.svg" alt="trash" className="w-[2.7vh] h-[2.7vh]" />
                            </button>}
                        </div>
                    </div>

                    <hr className="w-full my-1 border-gray-200" />

                    {/* Details section with left-aligned labels and right-aligned values */}
                    <div className="space-y-0.5 text-[2vh] mt-1 flex-grow leading-relaxed">
                        {/* Designation row */}
                        <div className="flex justify-between items-center mt-1">
                            <span className="text-gray-500 leading-relaxed">Designation</span>
                            <span
                                className="font-medium text-gray-800 truncate"
                                style={{ maxWidth: "9ch" }}
                                title={element.INSTITUTE_LEADER_DESIGNATION}
                            >
                                {element.INSTITUTE_LEADER_DESIGNATION}
                            </span>
                        </div>
                        {/* Qualification row */}
                        <div className="flex justify-between items-center mt-1">
                            <span className="text-gray-500">Qualification</span>
                            <span
                                className="font-medium text-gray-800 truncate leading-relaxed"
                                style={{ maxWidth: "10ch" }}
                                title={element.INSTITUTE_LEADER_QUALIFICATION}
                            >
                                {element.INSTITUTE_LEADER_QUALIFICATION}
                            </span>
                        </div>
                        {/* Experience row */}
                        <div className="flex justify-between items-center mt-1">
                            <span className="text-gray-500 leading-relaxed">Experience</span>
                            <span className="font-medium text-gray-800">
                                {element.INSTITUTE_LEADER_EXPERIENCE}
                            </span>
                        </div>
                        {/* Mobile row */}
                        <div className="flex justify-between items-center mt-1">
                            <span className="text-gray-500 leading-relaxed">Mobile</span>
                            <span
                                className="font-medium text-gray-800 truncate"
                                style={{ maxWidth: "10ch" }}
                                title={element.INSTITUTE_LEADER_MOBILE}
                            >
                                {element.INSTITUTE_LEADER_MOBILE}
                            </span>
                        </div>
                        {/* Email row */}
                        <div className="flex justify-between items-center mt-1">
                            <span className="text-gray-500 leading-relaxed">Email</span>
                            <span
                                className="font-medium text-gray-800 truncate"
                                style={{ maxWidth: "9ch" }}
                                title={element.INSTITUTE_LEADER_EMAIL}
                            >
                                {element.INSTITUTE_LEADER_EMAIL}
                            </span>
                        </div>
                    </div>
                </div>
     );
}
 
export default FounderActionCard;